import { Box, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EdgeConditionDTO } from '../../../api/generated';
import { CustomSwitch } from '../../Common/CustomSwitch';

interface EdgeConditionInputProps {
  condition: EdgeConditionDTO;
  onChange: (condition: EdgeConditionDTO) => void;
}

export default function EdgeConditionInput({ condition, onChange }: EdgeConditionInputProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', gap: '1em' }}>
      <FormControl>
        <InputLabel>{t('billableMaterial.operator')}</InputLabel>

        <Select
          size='small'
          label={t('billableMaterial.operator')}
          value={condition.operator}
          onChange={(e) => onChange({ ...condition, operator: e.target.value as any })}
          sx={{ width: '6em' }}
        >
          <MenuItem value='>'>&gt;</MenuItem>
          <MenuItem value='<'>&lt;</MenuItem>
          <MenuItem value='>='>&ge;</MenuItem>
          <MenuItem value='<='>&le;</MenuItem>
        </Select>
      </FormControl>
      <TextField
        size='small'
        label={t('billableMaterial.valueInM')}
        type='number'
        value={condition.value}
        onChange={(e) => onChange({ ...condition, value: parseFloat(e.target.value) })}
        sx={{ width: '7em' }}
      />
      <TextField
        size='small'
        label={t('billableMaterial.count')}
        type='number'
        value={condition.thresholdCount === undefined ? 1 : condition.thresholdCount}
        onChange={(e) => onChange({ ...condition, thresholdCount: parseInt(e.target.value) })}
        slotProps={{
          input: {
            sx: {
              '& input': {
                width: '5ch',
              },
            },
            startAdornment: (
              <InputAdornment position='start'>
                <CustomSwitch
                  options={[
                    { value: 'min', labelKey: 'common.min' },
                    { value: 'max', labelKey: 'common.max' },
                  ]}
                  value={condition.thresholdMode}
                  onToggle={(thresholdMode) => onChange({ ...condition, thresholdMode })}
                />
              </InputAdornment>
            ),
          },
          formHelperText: {
            sx: {
              position: 'absolute',
              top: '100%',
              whiteSpace: 'nowrap',
              margin: 0,
              left: '1rem',
              width: 'max-content',
              fontSize: '0.75rem',
            },
          },
        }}
        helperText={t(`billableMaterial.countInfo.${condition.thresholdMode}`)}
      />
    </Box>
  );
}
